/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* tslint:disable quotemark */
export default [
  "$script,redirect-rule=noop",
  "googleapis.com/js/sdkloade",
  "media,redirect=noopmp3-0.1",
  "/pagead/js/adsbygoogle.js",
  "$script,redirect=noopjs",
  "*$script,3p,denyallow=",
  "/wp-content/uploads/*",
  "/wp-content/plugins/",
  ".com^$third-party",
  "googlesyndication",
  ".cloudfront.net^",
  ",redirect-rule=",
  "$script,domain=",
  "xmlhttprequest",
  ".actonservice",
  "/^https?:\\/\\/",
  "^$third-party",
  "||smetrics.",
  "doubleclick",
  "third-party",
  "marketing.",
  ".website^",
  "analytics",
  "$script,",
  "cloudfla",
  "subdocum",
  "tracking",
  "domain=",
  "metrics",
  ".co.uk",
  "$ghide",
  "a8clk.",
  "cookie",
  "Cookie",
  "google",
  "script",
  ".com^",
  ".xyz^",
  "$xhr,",
  "a8cv.",
  "count",
  "image",
  "media",
  "track",
  "video",
  ".com",
  ".gif",
  ".jp^",
  ".net",
  ".php",
  "/js/",
  "$doc",
  "html",
  "stat",
  "www.",
  ".de",
  ".io",
  ".jp",
  ".js",
  ".ru",
  "$3p",
  "cdn",
  "new",
  "pro",
  "web",
  ".b",
  ".c",
  ".m",
  ".n",
  ".p",
  ".s",
  ".t",
  "@@",
  "*/",
  "/*",
  "/b",
  "/p",
  "||",
  "1p",
  "a-",
  "ab",
  "ac",
  "ad",
  "af",
  "ag",
  "ak",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "as",
  "at",
  "au",
  "av",
  "aw",
  "ay",
  "az",
  "be",
  "bl",
  "bo",
  "br",
  "ca",
  "ce",
  "ch",
  "ck",
  "cl",
  "ct",
  "de",
  "di",
  "do",
  "dr",
  "e-",
  "e^",
  "eb",
  "ec",
  "ed",
  "eg",
  "el",
  "em",
  "en",
  "ep",
  "er",
  "es",
  "et",
  "ev",
  "ew",
  "ex",
  "fa",
  "ff",
  "fi",
  "fo",
  "fr",
  "g^",
  "ge",
  "go",
  "gr",
  "he",
  "ho",
  "ic",
  "id",
  "ig",
  "ik",
  "il",
  "im",
  "in",
  "ip",
  "ir",
  "is",
  "it",
  "iv",
  "ix",
  "iz",
  "js",
  "le",
  "li",
  "lo",
  "ly",
  "ma",
  "mo",
  "mp",
  "my",
  "no",
  "od",
  "ok",
  "ol",
  "om",
  "on",
  "op",
  "or",
  "ot",
  "pl",
  "po",
  "pr",
  "qu",
  "re",
  "ro",
  "s-",
  "s/",
  "sc",
  "se",
  "sh",
  "si",
  "sm",
  "so",
  "sp",
  "ss",
  "st",
  "th",
  "ti",
  "to",
  "tr",
  "ts",
  "ub",
  "ud",
  "ug",
  "ul",
  "um",
  "un",
  "up",
  "ur",
  "us",
  "ut",
  "ve",
  "yo",
  "_",
  "-",
  ",",
  "?",
  ".",
  "*",
  "/",
  "\\",
  "^",
  "=",
  "|",
  "~",
  "$",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];